"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Kentaro Kawakatsu
 */
var KeyCode = /** @class */ (function () {
    function KeyCode() {
    }
    KeyCode.UP = 38;
    KeyCode.DOWN = 40;
    return KeyCode;
}());
exports.default = KeyCode;



//////////////////
// WEBPACK FOOTER
// ./src/ts/myLib/enum/ui/KeyCode.ts
// module id = 18
// module chunks = 0